"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Logo = Logo;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LogoTypography = (0, _styles.styled)(_material.Typography)(function (_ref) {
  var theme = _ref.theme;
  return {
    fontFamily: 'DM Sans'
  };
});
function Logo(_ref2) {
  var text = _ref2.text,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'title' : _ref2$variant;
  return /*#__PURE__*/_react["default"].createElement(LogoTypography, {
    variant: variant === 'title' ? 'h6' : 'h2',
    color: variant === 'title' ? 'inherit' : 'primary'
  }, text);
}